import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "bootstrap-touchspin" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTouchspin',
  setup(__props) {

const defaultTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/defaultTouchspin.vue"))
const outlinedTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/outlinedTouchspin.vue"))
const IconsTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/IconsTouchspin.vue"))
const postfixTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/postfixTouchspin.vue"))
const roundedTouchspin = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/touchspin/roundedTouchspin.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Widgets",
      title: "Touchspin"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(defaultTouchspin)),
          _createVNode(_unref(outlinedTouchspin)),
          _createVNode(_unref(IconsTouchspin)),
          _createVNode(_unref(postfixTouchspin)),
          _createVNode(_unref(roundedTouchspin))
        ])
      ])
    ])
  ], 64))
}
}

})